import { Component, computed, inject } from '@angular/core';

import { sortBy } from '@softline/core';
import { ModalService } from '../modal.service';
import { ModalComponent } from './modal/modal.component';
import { BreakpointService } from '../../utilities/breakpoints/services/breakpoint.service';

@Component({
  selector: 'soft-modal-container-2',
  imports: [ModalComponent],
  templateUrl: './modal-container.component.html',
  styleUrl: './modal-container.component.css',
})
export class ModalContainerComponent {
  service = inject(ModalService);

  readonly isMobile = inject(BreakpointService).isMobile;

  configs = computed(() => {
    const configs = this.service.configs();
    return sortBy(configs, 'priority', 'ASC');
  });

  activeConfig = computed(() => {
    const configs = this.configs();
    if (configs.length === 0) return null;
    return configs.slice(-1)[0];
  });
}
